
export function doFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
    // logger.log("@@@@ fetch: " + input + "\n" + JSON.stringify(init));

    return fetch(input, init);
}